module.exports = __webpack_public_path__ + "img/2.ffa5f7b1.jpg";